import React from 'react';
import classNames from 'classnames';
import { logos } from '@/assets/logos';
import styles from './Logo.module.scss';

interface LogoProps {
	className?: string;
	name: string;
	width?: number;
	height?: number;
}

/**
 * Generic Logo component used for displaying svg logos with specific width and height set on them. '
 * "name" should be one of the logos' file name exported from assets/logos.
 *
 * The difference between an Icon and Logo component is, that logos can (and should) have custom size.
 */
export const Logo: React.FunctionComponent<LogoProps> = ({ className, name, width, height }) => {
	return (
		<i
			className={classNames(styles.logo, { [styles.hasOverrideSize]: width }, className)}
			style={
				{
					'--width': width && `${width}px`,
					'--height': height && `${height}px`,
				} as React.CSSProperties
			}
		>
			<svg className={styles.asset}>
				<use xlinkHref={`#${logos[name]}`} />
			</svg>
		</i>
	);
};
